import { defineComponent as _defineComponent } from 'vue'
import { computed, Ref, ref } from "vue";
import DossierDownloadDialog from "@/components/dialogs/DossierDownloadDialog.vue";
import NjButton from "@/components/vuetify-wrappers/NjButton.vue";
import { useSessionStore } from "@/pinia/session";
import {
  TypedURLSearchParams,
  UniversalSearchParams,
} from "@/types/api/SearchEndpointInputs";
import { ApiService, SnackbarService } from "@/services";


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkDossierDownloadButton',
  props: {
    searchParams: null,
    documentName: null
  },
  setup(__props: any) {

const props = __props as {
  searchParams: Partial<UniversalSearchParams> | TypedURLSearchParams;
  documentName: string;
};



const sessionStore = useSessionStore();
const useCustomLogo = ref(sessionStore.hasCustomLogo);

const formatSelection = ref("docx");
const orderSelection = ref("alphabetical");
const customizationSelection = ref<string>("standard");

const display = ref(false);
const requestReceived = ref(false);
const downloadButtonText = computed(() => {
  return `Email Profile Book${
    requestReceived.value ? " (Request Received)" : ""
  }`;
});

const checking = ref(false);

function resettingUpdate<T>(target: Ref<T>) {
  return (value: T) => {
    target.value = value;
    requestReceived.value = false;
  };
}

const updateFormat = resettingUpdate(formatSelection);
const updateOrder = resettingUpdate(orderSelection);
const updateCustomization = resettingUpdate(customizationSelection);
const updateLogo = resettingUpdate(useCustomLogo);

const getAllParams = (): URLSearchParams => {
  let fileParams: URLSearchParams;
  if (props.searchParams instanceof TypedURLSearchParams) {
    fileParams = new URLSearchParams(props.searchParams.toString());
  } else {
    fileParams = new URLSearchParams();
    Object.entries(props.searchParams).forEach(([key, value]) => {
      if (typeof value === "string" && value.includes(",")) {
        value.split(",").forEach((v) => {
          fileParams.append(key, v);
        });
      } else {
        fileParams.append(key, value + "");
      }
    });
  }
  fileParams.append("datatype", formatSelection.value);
  fileParams.set("order", orderSelection.value);
  fileParams.append("doc_name", props.documentName);
  fileParams.append("use_custom_logo", useCustomLogo.value.toString());
  // Add pc_template_id when downloading PPTX with a selected custom template
  if (
    (formatSelection.value === "pptx" ||
      formatSelection.value === "zip_pptx") &&
    customizationSelection.value.startsWith("pc_template:")
  ) {
    const id = customizationSelection.value.split(":")[1];
    if (id) {
      fileParams.set("pc_template_id", String(Number(id)));
    }
  }
  return fileParams;
};

const user = sessionStore.user;
const isIpUser = computed(() => sessionStore.isIpUser);
const initiateEmail = async () => {
  const params = getAllParams() as TypedURLSearchParams;
  checking.value = true;
  const response = await ApiService.getBulkDossierEmail(params);
  if (response.ok) {
    requestReceived.value = true;
    const msg = `Your download is processing and will be emailed to ${user?.email} within the next few minutes.`;
    SnackbarService.displaySnackbar(msg, "primary");
  } else {
    SnackbarService.displaySnackbar(response.error?.message, "error");
  }
  checking.value = false;
};

return { __sfc: true,props, sessionStore, useCustomLogo, formatSelection, orderSelection, customizationSelection, display, requestReceived, downloadButtonText, checking, resettingUpdate, updateFormat, updateOrder, updateCustomization, updateLogo, getAllParams, user, isIpUser, initiateEmail, DossierDownloadDialog, NjButton }
}

})